"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 13/02/2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var FavouriteConverter_1 = require("./conversions/FavouriteConverter");

var FavouriteConverterImpl_1 = require("./conversions/FavouriteConverterImpl");
/**
 * Configures favourite app module.
 *
 * @author JMr
 */


var FavouriteAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(FavouriteAppModule, _AppModule_1$AppModul);

  function FavouriteAppModule() {
    var _this;

    _classCallCheck(this, FavouriteAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FavouriteAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'favouriteAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FavouriteAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(FavouriteConverter_1.FavouriteConverter).to(FavouriteConverterImpl_1.FavouriteConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return FavouriteAppModule;
}(AppModule_1.AppModule);

exports.FavouriteAppModule = FavouriteAppModule;